export default {
  id: 'associates',
  title: 'Klijenti (Associates)',
  icon: 'mdi-account-multiple',
  show: true,
  order: 9,
  children: [
    {
      id: 'associates-overview',
      title: 'Pregled klijenata',
      icon: 'mdi-view-list',
      show: true,
      order: 1,
      content: () => `
        <h2 id="associates-overview">Pregled klijenata</h2>
        <p>
          Modul "Klijenti" (Associates) omogućava vođenje evidencije svih vaših kupaca - fizičkih i pravnih osoba.
          Klijenti su potrebni za izdavanje R1 i R2 računa, praćenje dugovanja, kredita i povijesti kupnje.
        </p>

        <h3 class="mt-4">Što su klijenti (Associates)?</h3>

        <p>
          Klijenti u AI Kasa sustavu predstavljaju:
        </p>
        <ul>
          <li><strong>Fizičke osobe</strong> - Individualni kupci s OIB-om</li>
          <li><strong>Pravne osobe</strong> - Tvrtke i poduzeća s OIB-om i dodatnim podacima</li>
          <li><strong>Inozemni kupci</strong> - Kupci iz EU i izvan EU</li>
        </ul>

        <h3 class="mt-4">Zašto voditi evidenciju klijenata?</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Prednost</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>R1/R2 računi</strong></td>
              <td>Izdavanje fiskalnih računa na pravne osobe</td>
            </tr>
            <tr>
              <td><strong>Praćenje dugovanja</strong></td>
              <td>Evidencija dugova i kredita kupaca</td>
            </tr>
            <tr>
              <td><strong>Povijest kupnje</strong></td>
              <td>Pregled svih računa po klijentu</td>
            </tr>
            <tr>
              <td><strong>Loyalty programi</strong></td>
              <td>Popusti i posebni cjenici za VIP kupce</td>
            </tr>
            <tr>
              <td><strong>Izvještaji</strong></td>
              <td>Analiza prodaje po kupcima</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Pristup pregledu klijenata</h3>

        <ol>
          <li>Iz glavnog izbornika idite na <strong>"Klijenti" → "Pregled klijenata"</strong></li>
          <li>Otvorit će se lista svih klijenata</li>
          <li>Možete pretraživati, filtrirati i sortirati klijente</li>
        </ol>

        <h3 class="mt-4">Prikaz klijenta u listi</h3>

        <p>Svaki klijent prikazuje sljedeće informacije:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Kolona</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Naziv/Ime</strong></td>
              <td>Ime i prezime (fizička osoba) ili naziv tvrtke</td>
            </tr>
            <tr>
              <td><strong>OIB</strong></td>
              <td>Osobni identifikacijski broj (11 znamenki)</td>
            </tr>
            <tr>
              <td><strong>Tip</strong></td>
              <td>Fizička osoba / Pravna osoba</td>
            </tr>
            <tr>
              <td><strong>Adresa</strong></td>
              <td>Ulica, grad, poštanski broj</td>
            </tr>
            <tr>
              <td><strong>Kontakt</strong></td>
              <td>Telefon, email</td>
            </tr>
            <tr>
              <td><strong>Dugovanje</strong></td>
              <td>Trenutni dug klijenta</td>
            </tr>
            <tr>
              <td><strong>Kredit</strong></td>
              <td>Odobreni kredit/limit</td>
            </tr>
            <tr>
              <td><strong>Status</strong></td>
              <td>Aktivan / Neaktivan / Blokiran</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Tipovi klijenata</h3>

        <h4 class="mt-3">1. Fizička osoba</h4>
        <p>Individualni kupci:</p>
        <ul>
          <li>Ime i prezime</li>
          <li>OIB (obavezan za R1/R2 račune)</li>
          <li>Adresa</li>
          <li>Kontakt podaci</li>
        </ul>

        <h4 class="mt-3">2. Pravna osoba</h4>
        <p>Tvrtke i poduzeća:</p>
        <ul>
          <li>Naziv tvrtke</li>
          <li>OIB tvrtke</li>
          <li>Sjedište tvrtke</li>
          <li>Kontakt osoba</li>
          <li>Telefon, email, web</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>OIB provjera:</strong> Sustav automatski provjerava valjanost OIB-a prilikom unosa.
            OIB mora biti 11-znamenkasti broj s ispravnim kontrolnim brojem.
          </div>
        </div>

        <h3 class="mt-4">Pretraživanje klijenata</h3>

        <h4 class="mt-3">Osnovno pretraživanje</h4>
        <p>Koristite polje za pretraživanje:</p>
        <ul>
          <li>Unesite ime ili naziv tvrtke</li>
          <li>Unesite OIB</li>
          <li>Unesite telefon ili email</li>
          <li>Sustav automatski filtrira rezultate</li>
        </ul>

        <h4 class="mt-3">Napredno filtriranje</h4>
        <p>Kliknite na <i class="mdi mdi-filter"></i> "Filteri":</p>
        <ul>
          <li><strong>Po tipu</strong> - Fizičke ili pravne osobe</li>
          <li><strong>Po statusu</strong> - Aktivni, neaktivni ili blokirani</li>
          <li><strong>S dugom</strong> - Samo klijenti s otvorenim dugom</li>
          <li><strong>Po gradu</strong> - Filtrirajte po lokaciji</li>
        </ul>

        <h3 class="mt-4">Akcije nad klijentima</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Akcija</th>
              <th>Ikona</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Detalji</strong></td>
              <td><i class="mdi mdi-eye"></i></td>
              <td>Pregled svih podataka, dugovanja i računa</td>
            </tr>
            <tr>
              <td><strong>Uredi</strong></td>
              <td><i class="mdi mdi-pencil"></i></td>
              <td>Izmjena podataka klijenta</td>
            </tr>
            <tr>
              <td><strong>Izdaj račun</strong></td>
              <td><i class="mdi mdi-receipt"></i></td>
              <td>Brzi pristup izdavanju računa na klijenta</td>
            </tr>
            <tr>
              <td><strong>Povijest računa</strong></td>
              <td><i class="mdi mdi-history"></i></td>
              <td>Svi izdani računi za tog klijenta</td>
            </tr>
            <tr>
              <td><strong>Blokiraj</strong></td>
              <td><i class="mdi mdi-cancel"></i></td>
              <td>Blokiranje klijenta (npr. zbog neplaćenog duga)</td>
            </tr>
            <tr>
              <td><strong>Obriši</strong></td>
              <td><i class="mdi mdi-delete"></i></td>
              <td>Trajno brisanje klijenta (samo ako nema računa)</td>
            </tr>
          </tbody>
        </table>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Klijente koji imaju izdane račune nije moguće obrisati.
            Možete ih deaktivirati ili blokirati.
          </div>
        </div>

        <h3 class="mt-4">Dugovanja i krediti</h3>

        <h4 class="mt-3">Praćenje dugovanja</h4>
        <p>Za svakog klijenta možete pratiti:</p>
        <ul>
          <li><strong>Trenutni dug</strong> - Ukupan iznos neplaćenih računa</li>
          <li><strong>Odobreni kredit</strong> - Maksimalni dopušteni dug</li>
          <li><strong>Dostupni kredit</strong> - Odobreni kredit minus trenutni dug</li>
          <li><strong>Dospijeće</strong> - Datum do kada račun treba biti plaćen</li>
        </ul>

        <h4 class="mt-3">Blokiranje klijenta</h4>
        <p>Klijent se automatski blokira ako:</p>
        <ul>
          <li>Premaši odobreni kredit</li>
          <li>Ima račune preko dospijeća</li>
          <li>Administrator ručno blokira klijenta</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Redovito pregledavajte izvještaj dugovanja kako biste na vrijeme
            reagirali na neplaćene račune i kontaktirali klijente.
          </div>
        </div>

        <h3 class="mt-4">Dodavanje novog klijenta</h3>

        <p>Za kreiranje novog klijenta:</p>
        <ol>
          <li>Kliknite <strong>"+ Dodaj klijenta"</strong></li>
          <li>Odaberite tip (Fizička ili Pravna osoba)</li>
          <li>Popunite obavezna polja</li>
          <li>Spremite</li>
        </ol>

        <h3 class="mt-4">Export i Import</h3>

        <h4 class="mt-3">Export klijenata</h4>
        <ol>
          <li>Kliknite <i class="mdi mdi-download"></i> "Export"</li>
          <li>Odaberite format: Excel (.xlsx) ili CSV</li>
          <li>Preuzmite datoteku</li>
        </ol>

        <h4 class="mt-3">Import klijenata</h4>
        <ol>
          <li>Kliknite <i class="mdi mdi-upload"></i> "Import"</li>
          <li>Preuzmite predložak (template)</li>
          <li>Popunite klijente u Excel datoteci</li>
          <li>Učitajte datoteku i pokrenite import</li>
        </ol>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Je li OIB obavezan?</h4>
        <p>
          OIB je obavezan samo za izdavanje R1 i R2 računa. Za obične fiskalne račune
          nije potreban OIB klijenta.
        </p>

        <h4 class="mt-3">Mogu li imati dva klijenta s istim OIB-om?</h4>
        <p>
          Ne, OIB mora biti jedinstven u sustavu. Ako pokušate dodati klijenta s već postojećim OIB-om,
          sustav će prikazati upozorenje.
        </p>

        <h4 class="mt-3">Kako evidentiram plaćanje duga?</h4>
        <p>
          Idite u detalje klijenta, kliknite "Evidentiraj plaćanje" i unesite iznos.
          Sustav će automatski ažurirati dug klijenta.
        </p>

        <h4 class="mt-3">Što je razlika između blokiranja i deaktiviranja?</h4>
        <p>
          <strong>Blokiranje</strong> sprječava izdavanje novih računa na tog klijenta.<br>
          <strong>Deaktiviranje</strong> samo sakriva klijenta iz liste, ali se može reaktivirati.
        </p>
      `
    },
    {
      id: 'associates-add',
      title: 'Dodavanje klijenta',
      icon: 'mdi-plus',
      show: true,
      order: 2,
      content: () => `
        <h2 id="add-client">Dodavanje klijenta (Associate)</h2>
        <p>
          Klijenti (Associates) su fizičke ili pravne osobe kojima izdajete račune.
          Spremanjem klijenta omogućavate brzo izdavanje računa i praćenje prodaje po klijentu.
        </p>

        <h3 class="mt-4">Korak po korak</h3>

        <h4 class="mt-3">1. Otvaranje forme</h4>
        <ol>
          <li>Idite na <strong>"Klijenti (Associates)"</strong></li>
          <li>Kliknite <strong>"+ Dodaj klijenta"</strong></li>
        </ol>

        <h4 class="mt-3">2. Odabir tipa klijenta</h4>
        <ul>
          <li><strong>Fizička osoba</strong> - Pojedinac (ime, prezime)</li>
          <li><strong>Pravna osoba</strong> - Tvrtka ili ustanova (naziv firme, OIB)</li>
        </ul>

        <h4 class="mt-3">3. Osnovni podaci (Fizička osoba)</h4>
        <table class="info-table">
          <thead>
            <tr>
              <th>Polje</th>
              <th>Obavezno</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Ime *</strong></td>
              <td>Da</td>
              <td>Ime klijenta</td>
            </tr>
            <tr>
              <td><strong>Prezime *</strong></td>
              <td>Da</td>
              <td>Prezime klijenta</td>
            </tr>
            <tr>
              <td><strong>OIB</strong></td>
              <td>Ne</td>
              <td>11-znamenkasti OIB (za R1/R2 račune)</td>
            </tr>
            <tr>
              <td><strong>Email</strong></td>
              <td>Ne</td>
              <td>Email adresa (za slanje računa)</td>
            </tr>
            <tr>
              <td><strong>Telefon</strong></td>
              <td>Ne</td>
              <td>Kontakt telefon</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">4. Osnovni podaci (Pravna osoba)</h4>
        <table class="info-table">
          <thead>
            <tr>
              <th>Polje</th>
              <th>Obavezno</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Naziv firme *</strong></td>
              <td>Da</td>
              <td>Službeni naziv tvrtke</td>
            </tr>
            <tr>
              <td><strong>OIB *</strong></td>
              <td>Da</td>
              <td>11-znamenkasti OIB firme (obavezan za R2)</td>
            </tr>
            <tr>
              <td><strong>Kontakt osoba</strong></td>
              <td>Ne</td>
              <td>Ime osobe za kontakt</td>
            </tr>
            <tr>
              <td><strong>Email</strong></td>
              <td>Ne</td>
              <td>Email za slanje računa</td>
            </tr>
            <tr>
              <td><strong>Telefon</strong></td>
              <td>Ne</td>
              <td>Kontakt telefon</td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>R1 vs R2 račun:</strong><br>
            • <strong>R1</strong> - račun za fizičku osobu (OIB nije obavezan)<br>
            • <strong>R2</strong> - račun za pravnu osobu (OIB je obavezan)
          </div>
        </div>

        <h4 class="mt-3">5. Adresa</h4>
        <ul>
          <li><strong>Ulica i broj</strong></li>
          <li><strong>Poštanski broj</strong></li>
          <li><strong>Grad</strong></li>
          <li><strong>Država</strong></li>
        </ul>

        <h4 class="mt-3">6. Dodatne informacije (opcionalno)</h4>
        <ul>
          <li><strong>Popust</strong> - Zadani popust za ovog klijenta (npr. 10%)</li>
          <li><strong>Način plaćanja</strong> - Preferirani način (Gotovina, Kartica, Virman)</li>
          <li><strong>Rok plaćanja</strong> - Za račune na rate (npr. 30 dana)</li>
          <li><strong>Napomena</strong> - Dodatne bilješke</li>
        </ul>

        <h4 class="mt-3">7. Spremanje</h4>
        <ol>
          <li>Provjerite podatke</li>
          <li>Kliknite <strong>"Spremi"</strong></li>
          <li>Klijent je sada dostupan pri izdavanju računa</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Spremite često korištene klijente da ubrzate izdavanje računa. Na blagajni možete brzo pronaći klijenta po imenu ili OIB-u.
          </div>
        </div>

        <h3 class="mt-4">Brzo dodavanje na blagajni</h3>
        <p>Možete dodati klijenta direktno pri izdavanju računa:</p>
        <ol>
          <li>Na blagajni kliknite <strong>"Dodaj klijenta"</strong></li>
          <li>Unesite osnovne podatke (ime, OIB)</li>
          <li>Kliknite <strong>"Spremi i dodaj na račun"</strong></li>
        </ol>

        <h2 id="tips" class="mt-6">Česta pitanja</h2>
        <ul>
          <li><strong>Moram li unijeti OIB?</strong> - Za R1 (fizičke osobe) nije obavezan, za R2 (pravne osobe) jest</li>
          <li><strong>Mogu li obrisati klijenta?</strong> - Ne, klijente možete samo deaktivirati</li>
          <li><strong>Kako izvesti listu klijenata?</strong> - U modulu Klijenti postoji gumb "Izvoz" za Excel/CSV</li>
        </ul>
      `
    },
    {
      id: 'associates-receipts',
      title: 'Izdavanje računa na klijenta',
      icon: 'mdi-receipt',
      show: true,
      order: 3,
      content: () => `
        <h2 id="client-receipts">Izdavanje računa na klijenta</h2>
        <p>
          Izdavanje računa na klijenta omogućava generiranje R1 ili R2 fiskalnog računa s podacima
          pravne ili fizičke osobe. Ovo je ključno za B2B (business-to-business) transakcije gdje
          kupac zahtijeva račun s OIB-om za potrebe knjig ovodstva.
        </p>

        <h3 class="mt-4">Tipovi računa na klijenta</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Tip računa</th>
              <th>Opis</th>
              <th>Kada koristiti</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>R1 račun</strong></td>
              <td>Fiskalni račun na pravnu osobu (tvrtku)</td>
              <td>Prodaja tvrtkama i poduzećima</td>
            </tr>
            <tr>
              <td><strong>R2 račun</strong></td>
              <td>Fiskalni račun na fizičku osobu</td>
              <td>Prodaja pojedincima koji trebaju osobni OIB</td>
            </tr>
            <tr>
              <td><strong>Obični fiskalni račun</strong></td>
              <td>Račun bez podataka kupca</td>
              <td>Standardna maloprodaja</td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Za R1/R2 račune obavezno je imati evidentirane podatke klijenta
            u modulu "Klijenti", uključujući OIB.
          </div>
        </div>

        <h3 class="mt-4">Način 1: Izdavanje računa s blagajne</h3>

        <h4 class="mt-3">Korak po korak</h4>

        <ol>
          <li>Otvorite smjenu na blagajni</li>
          <li>Dodajte artikle u račun (kao za obični račun)</li>
          <li>Prije finalizacije kliknite <i class="mdi mdi-account"></i> <strong>"Odaberi klijenta"</strong></li>
          <li>Pretražite i odaberite klijenta iz liste ili dodajte novog</li>
          <li>Odaberite način plaćanja</li>
          <li>Kliknite <strong>"Naplati"</strong></li>
          <li>Račun će biti fiskaliziran s podacima klijenta</li>
        </ol>

        <h4 class="mt-3">Pretraživanje klijenta na blagajni</h4>
        <p>Možete brzo pronaći klijenta pomoću:</p>
        <ul>
          <li><strong>Imena/Naziva</strong> - Upišite dio naziva tvrtke ili ime osobe</li>
          <li><strong>OIB-a</strong> - Upišite OIB klijenta</li>
          <li><strong>Telefona</strong> - Upišite telefonski broj</li>
          <li><strong>Barkoda</strong> - Skenirajte člansku karticu klijenta (ako je definirana)</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Ako često izdajete račune istim klijentima, definirajte im kartice s barkodima.
            Tako možete brzo odabrati klijenta skeniranjem kartice.
          </div>
        </div>

        <h3 class="mt-4">Način 2: Izdavanje računa iz modula klijenata</h3>

        <ol>
          <li>Idite na <strong>"Klijenti" → "Pregled klijenata"</strong></li>
          <li>Pronađite klijenta u listi</li>
          <li>Kliknite <i class="mdi mdi-receipt"></i> <strong>"Izdaj račun"</strong></li>
          <li>Otvorit će se forma za kreiranje računa s već odabranim klijentom</li>
          <li>Dodajte artikle</li>
          <li>Odaberite način plaćanja i finalizirajte</li>
        </ol>

        <h3 class="mt-4">Podaci na R1/R2 računu</h3>

        <p>Račun na klijenta sadrži sve standardne podatke plus:</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Podatak</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Kupac</strong></td>
              <td>Naziv tvrtke ili ime i prezime fizičke osobe</td>
            </tr>
            <tr>
              <td><strong>OIB kupca</strong></td>
              <td>11-znamenkasti OIB</td>
            </tr>
            <tr>
              <td><strong>Adresa kupca</strong></td>
              <td>Puna adresa: ulica, broj, grad, poštanski broj</td>
            </tr>
            <tr>
              <td><strong>Način plaćanja</strong></td>
              <td>Gotovina, Kartica, Virman, Odgođeno</td>
            </tr>
            <tr>
              <td><strong>JIR i ZKI</strong></td>
              <td>Jedinstveni identifikatori fiskalnog računa</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Načini plaćanja</h3>

        <h4 class="mt-3">1. Gotovina ili kartica (trenutno plaćanje)</h4>
        <p>
          Klijent plaća odmah. Račun se fiskalizira i evidentira kao plaćen.
        </p>

        <h4 class="mt-3">2. Virman (račun na odgodu)</h4>
        <p>
          Klijent će platiti naknadno putem bankovnog prijenosa:
        </p>
        <ul>
          <li>Račun se fiskalizira</li>
          <li>Evidentira se kao neplaćen</li>
          <li>Dodaje se u dug klijenta</li>
          <li>Definira se datum dospijeća (npr. 15 dana)</li>
          <li>Kada klijent plati, potrebno je ručno evidentirati uplatu</li>
        </ul>

        <h4 class="mt-3">3. Odgođeno plaćanje (na kredit)</h4>
        <p>
          Klijent ima odobreni kredit i plaća naknadno:
        </p>
        <ul>
          <li>Provjerava se dostupni kredit klijenta</li>
          <li>Ako ima dovoljno kredita, račun se može izdati</li>
          <li>Dodaje se u ukupni dug klijenta</li>
          <li>Definirano je dospijeće plaćanja</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Ako klijent premaši odobreni kredit ili ima račune preko dospijeća,
            sustav može blokirati izdavanje novih računa. Administrator može odobriti izuzetno izdavanje.
          </div>
        </div>

        <h3 class="mt-4">Evidencija plaćanja duga</h3>

        <p>Kada klijent plati dug:</p>
        <ol>
          <li>Idite u <strong>"Klijenti" → Odaberite klijenta</strong></li>
          <li>Kliknite <strong>"Evidentiraj plaćanje"</strong></li>
          <li>Unesite iznos plaćanja</li>
          <li>Odaberite račune koje plaćanje pokriva</li>
          <li>Unesite napomenu (broj transakcije, referenca)</li>
          <li>Spremite</li>
        </ol>

        <p>Sustav će automatski:</p>
        <ul>
          <li>Označiti plaćene račune</li>
          <li>Smanjiti ukupni dug klijenta</li>
          <li>Povećati dostupni kredit</li>
          <li>Evidentirati uplatu u knjizi uplate</li>
        </ul>

        <h3 class="mt-4">Povijest računa klijenta</h3>

        <p>Za pregled svih računa klijenta:</p>
        <ol>
          <li>Idite na <strong>"Klijenti" → Odaberite klijenta</strong></li>
          <li>Kliknite na tab <strong>"Računi"</strong></li>
          <li>Prikazat će se lista svih izdanih računa</li>
        </ol>

        <p>Za svaki račun možete vidjeti:</p>
        <ul>
          <li>Broj i datum računa</li>
          <li>Iznos računa</li>
          <li>Status: Plaćen / Neplaćen / Djelomično plaćen</li>
          <li>Dospijeće</li>
          <li>JIR broj</li>
          <li>PDF pregled računa</li>
        </ul>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Mogu li izdati račun bez OIB-a klijenta?</h4>
        <p>
          Ne, za R1/R2 račune OIB je obavezan. Ako klijent nema OIB ili ne želi dati podatke,
          izdajte obični fiskalni račun bez klijenta.
        </p>

        <h4 class="mt-3">Što ako krivo odaberem klijenta?</h4>
        <p>
          Račun se ne može promijeniti nakon fiskalizacije. Morate stornirati račun i izdati novi
          na ispravnog klijenta.
        </p>

        <h4 class="mt-3">Kako provjeriti da li klijent ima neplaćene račune?</h4>
        <p>
          U pregledu klijenata, kolona "Dugovanje" prikazuje ukupan dug. Kliknite na klijenta
          za detaljan prikaz neplaćenih računa.
        </p>

        <h4 class="mt-3">Može li klijent imati više otvorenih računa?</h4>
        <p>
          Da, klijent može imati neograničen broj neplaćenih računa, sve dok ne premaši odobreni kredit.
        </p>

        <h4 class="mt-3">Kako postaviti odobreni kredit klijentu?</h4>
        <p>
          Uredite klijenta i u polju "Odobreni kredit" unesite maksimalni dopušteni iznos duga.
          Na primjer, 10,000.00 EUR.
        </p>
      `
    }
  ]
}
